import { render, staticRenderFns } from "./ReturnDeliveryAmtGuide.vue?vue&type=template&id=d97aeda8&scoped=true&"
import script from "./ReturnDeliveryAmtGuide.vue?vue&type=script&lang=ts&"
export * from "./ReturnDeliveryAmtGuide.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnDeliveryAmtGuide.vue?vue&type=style&index=0&id=d97aeda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97aeda8",
  null
  
)

export default component.exports